(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/ticket-partner/assets/react/pages/physical-tickets/receipt/receipt.js') >= 0) return;  svs.modules.push('/modules/ticket-partner/assets/react/pages/physical-tickets/receipt/receipt.js');
"use strict";


const {
  useContext,
  useEffect,
  Fragment
} = React;
const {
  InformationPanels
} = svs.ticket_partner.sharedComponents.informationPanels;
const PageWrapper = svs.ticket_partner.sharedComponents.pageWrapper.PageWrapper;
const ReceiptComponent = svs.ticket_partner.sharedComponents.receipt.Receipt;
const {
  PHYSICAL_RECEIPT
} = svs.ticket_partner.sharedComponents.receipt.constants.TEXTS;
const {
  PHYSICAL_TICKETS
} = svs.ticket_partner.constants.routes;
const {
  CLEAR_STATE
} = svs.ticket_partner.physicalTickets.actions;
const Receipt = _ref => {
  var _svs$ticket_partner$d;
  let {
    history
  } = _ref;
  const {
    state,
    dispatch
  } = useContext(svs.ticket_partner.PhysicalTicketsContext);
  useEffect(() => {
    if (state.orderSuccess) {
      dispatch({
        type: CLEAR_STATE
      });
    } else {
      history.push(PHYSICAL_TICKETS);
    }
  }, [dispatch, history]);
  return React.createElement(Fragment, null, React.createElement(PageWrapper, null, React.createElement(ReceiptComponent, {
    type: PHYSICAL_RECEIPT
  })), React.createElement(InformationPanels, {
    articles: (_svs$ticket_partner$d = svs.ticket_partner.data) === null || _svs$ticket_partner$d === void 0 || (_svs$ticket_partner$d = _svs$ticket_partner$d.articles) === null || _svs$ticket_partner$d === void 0 ? void 0 : _svs$ticket_partner$d.physicalTrissArticles
  }));
};
svs.ticket_partner.physicalTickets.receipt.Receipt = Receipt;

 })(window);